import React, { useMemo } from 'react';
import { Input as AntdInput } from 'antd';

import styles from './LabeledInput.module.scss';

export const LabeledInput = React.forwardRef(({
  label,
  disabled,
  withAsterisks,
  password,
  id,
  isTextArea = false,
  ...props }, ref) => {
  const hasAsterisks = useMemo(() => {
    if (withAsterisks === false) { return false; }

    return withAsterisks || (
      props['data-__meta'] && props['data-__meta'].rules
            && props['data-__meta'].rules.some(item => item.required === true)
    );
  }, [ props ]);

  const InputField = isTextArea ? AntdInput.TextArea : AntdInput;

  return (
    password
      ? (
        <div ref={ ref } className={ styles.inputWrapper }>
          <label
            data-testid={ `${id}-label` }
            className={ styles.label }
            style={ disabled ? { color: '#999' } : { color: '#57a7d7' } }
          >
            {`${label}`}
            {hasAsterisks && <span className={ styles.asterisks }>{' *'}</span>}
          </label>
          <div className={ styles.inputField }>
            <AntdInput.Password
              data-testid={ id }
              style={ styles }
              allowClear
              className={ disabled ? styles.isDisabled : '' }
              disabled={ disabled }
              id={ id }
              { ...props }
            />
          </div>
        </div>
      )
      : (
        <div ref={ ref } className={ styles.inputWrapper }>
          <label
            data-testid={ `${id}-label` }
            className={ styles.label }
            style={ disabled ? { color: '#999' } : { color: '#57a7d7' } }
          >
            {`${label}`}
            {hasAsterisks && <span className={ styles.asterisks }>{' *'}</span>}
          </label>
          <div className={ styles.inputField }>
            <InputField
              data-testid={ id }
              style={ styles }
              allowClear
              className={ disabled ? styles.isDisabled : '' }
              disabled={ disabled }
              id={ id }
              { ...props }
            />
          </div>
        </div>
      )
  );
});
